import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import type { AdvancedMentoringProductDTO } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { H4 } from '@/frontend/design-system/_marketing/typography/Heading/H4';
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph/P3';
import { Field, Fieldset, Label } from '@/frontend/design-system/forms/Fieldset';
import { Input } from '@/frontend/design-system/forms/Input';
import { Slider } from '@/frontend/design-system/forms/Slider/Slider';
import { Switch } from '@/frontend/design-system/forms/Switch';
import { MAXIMUM_LINES_OF_CODE, MINIMUM_LINES_OF_CODE } from '../../prices';
type CodeInspectionProps = {
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  updateProduct: (updates: Partial<AdvancedMentoringProductDTO> | ((prev: AdvancedMentoringProductDTO) => Partial<AdvancedMentoringProductDTO>)) => void;
};
export function CodeInspection(t0) {
  const $ = _c(16);
  const {
    advancedMentoringProduct,
    updateProduct
  } = t0;
  const linesOfCode = advancedMentoringProduct.linesOfCode;
  const [isCodeInspectionOpen, setIsCodeInspectionOpen] = useState(linesOfCode > 0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H4>Inspekcja kodu</H4>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== updateProduct) {
    t2 = () => {
      setIsCodeInspectionOpen(_temp);
      updateProduct(_temp2);
    };
    $[1] = updateProduct;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isCodeInspectionOpen || $[4] !== t2) {
    t3 = <div className="flex items-center justify-between">{t1}<Switch checked={isCodeInspectionOpen} onChange={t2} /></div>;
    $[3] = isCodeInspectionOpen;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <P3>Mentor przejrzy Twój kod i dostarczy szczegółowe uwagi dotyczące jakości, architektury i najlepszych praktyk programistycznych.</P3>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isCodeInspectionOpen || $[8] !== linesOfCode || $[9] !== updateProduct) {
    t5 = isCodeInspectionOpen && <div className="flex flex-col items-end gap-1 sm:flex-row sm:gap-6"><div className="flex w-full flex-1 flex-col gap-2"><Slider variant="single" min={MINIMUM_LINES_OF_CODE} max={MAXIMUM_LINES_OF_CODE} step={1000} value={[linesOfCode]} onValueChange={value => updateProduct({
          linesOfCode: value[0]
        })} /><div className="flex justify-between text-slate-600 text-sm"><p>{MINIMUM_LINES_OF_CODE} linii</p><p>{MAXIMUM_LINES_OF_CODE} linii</p></div></div><Fieldset disabled={true} className="w-36 self-center"><Field><Label>Liczba linii kodu</Label><Input value={linesOfCode} type="number" /></Field></Fieldset></div>;
    $[7] = isCodeInspectionOpen;
    $[8] = linesOfCode;
    $[9] = updateProduct;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="space-y-6 sm:space-y-2">{t4}{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <IconOnTheLeftWithContentLayout mainContent={t3}>{t6}</IconOnTheLeftWithContentLayout>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp2(prev_0) {
  return {
    linesOfCode: prev_0.linesOfCode > 0 ? 0 : MINIMUM_LINES_OF_CODE
  };
}
function _temp(prev) {
  return !prev;
}